<template>
  <div class="">
    <DesktopSubHeader />
    <MobileSubHeader />
  </div>
</template>

<script>
	import DesktopSubHeader from './DesktopSubHeader'
	import MobileSubHeader  from './MobileSubHeader'

	export default {
		components : {
			DesktopSubHeader,
			MobileSubHeader
		}
	}
</script>